import { Building2, Users, Clock } from "lucide-react";
import { useLang } from "@/context/LangContext";

const TEAM_IMG =
  "https://customer-assets.emergentagent.com/job_85512f74-aa35-4a50-bb9f-c899943066c1/artifacts/stdmws72_1.jpg";

export default function About({ content }) {
  const { lang, t, pick } = useLang();

  return (
    <section id="about" className="afb-section bg-white" data-testid="about-section">
      <div className="afb-container grid grid-cols-1 lg:grid-cols-2 gap-10 sm:gap-14 items-center">
        <div className="relative">
          <div className="aspect-[4/5] overflow-hidden rounded-md">
            <img
              src={TEAM_IMG}
              alt="Il nostro team"
              className="w-full h-full object-cover"
              data-testid="about-team-photo"
            />
          </div>
          <div className="absolute -bottom-6 -right-6 hidden md:block bg-afb-ink text-white px-7 py-5 rounded-md max-w-[220px]">
            <div className="text-3xl serif text-afb-gold leading-none">
              {content?.stats_agencies ?? 53}
            </div>
            <div className="text-xs uppercase tracking-[0.22em] mt-1 text-white/70">
              {t("sections.stats_agencies")}
            </div>
          </div>
        </div>

        <div>
          <span className="afb-eyebrow">{t("sections.about_label")}</span>
          <h2 className="serif text-[1.7rem] sm:text-3xl md:text-4xl lg:text-5xl mt-3 leading-[1.15] text-afb-ink">
            {t("sections.about_subtitle")}
          </h2>
          <span className="block mt-5 h-[2px] w-16 sm:w-20 bg-[color:var(--afb-gold)]" />

          <p className="mt-6 sm:mt-7 text-[15px] sm:text-lg leading-relaxed text-afb-ink/80 italic serif">
            “{pick(content, "about_intro")}”
          </p>
          <p className="mt-4 sm:mt-5 text-[15px] sm:text-base leading-relaxed text-afb-muted">
            {pick(content, "about_mission")}
          </p>

          <div className="mt-8 sm:mt-10 grid grid-cols-3 gap-3 sm:gap-4">
            <Stat
              icon={<Building2 className="w-5 h-5" />}
              value={content?.stats_agencies ?? 53}
              label={t("sections.stats_agencies")}
              testId="stat-agencies"
            />
            <Stat
              icon={<Users className="w-5 h-5" />}
              value={content?.stats_employees ?? 45}
              label={t("sections.stats_employees")}
              testId="stat-employees"
            />
            <Stat
              icon={<Clock className="w-5 h-5" />}
              value="24/7"
              label={t("sections.stats_h24")}
              testId="stat-h24"
            />
          </div>

          <div className="mt-8 sm:mt-10 p-5 sm:p-6 border-l-2 border-afb-gold bg-afb-cream/40 rounded-r-md">
            <span className="afb-eyebrow">{t("sections.consorzio_label")}</span>
            <p className="mt-3 text-sm sm:text-base leading-relaxed text-afb-ink/85">
              {pick(content, "consorzio_text")}
            </p>
            <p className="mt-3 text-xs text-afb-muted">{content?.address_consorzio}</p>
          </div>

          {/* anti-unused warning for `lang` */}
          <span className="sr-only">{lang}</span>
        </div>
      </div>
    </section>
  );
}

function Stat({ icon, value, label, testId }) {
  return (
    <div
      className="text-center p-4 border-t border-[color:var(--afb-cream)]"
      data-testid={testId}
    >
      <div className="inline-flex items-center justify-center w-9 h-9 rounded-full bg-afb-cream text-afb-gold mb-2">
        {icon}
      </div>
      <div className="serif text-3xl text-afb-ink leading-none">{value}</div>
      <div className="text-[10px] uppercase tracking-[0.2em] text-afb-muted mt-2">
        {label}
      </div>
    </div>
  );
}
